import { createSelector } from 'reselect';
import { redux } from 'Core/redux';
import { STORE_KEY, INITIAL_STATE } from './slice';

export const selectState = state => {
  const appState = state || redux.store.getState();
  return appState?.[STORE_KEY] || INITIAL_STATE;
};

export const selectCarrierData = state => selectState(state).data;
export const selectCarrierLoading = state => selectState(state).loading;
export const selectCarrierError = state => selectState(state).error;
export const selectCarrierFilterVisible = state => selectState(state).filterVisible;
export const selectCarrierFilters = state => selectState(state).filters;
export const selectTileView = state => selectState(state).tileView;

export const selectFilteredCarriers = createSelector(
  [selectCarrierData, selectCarrierFilters],
  (data, { searchText }) => {
    const q = (searchText || '').toLowerCase();
    if (!q) return data;
    return data.filter(entry =>
      Object.keys(entry).some(key => String(entry[key] ?? '').toLowerCase().includes(q)),
    );
  },
);

